import React from 'react';
import type { OptionTypeBase } from 'react-select';
import type { SectionProps } from '../Home';
import { CollapseSection } from '../modules';
import { AccessCode } from '../../../components';
import { useI18n } from '@whizz/react-i18n';
import StudentLogins from '../../StudentLogins/StudentLogins';

interface LoginDetailsProps extends Pick<SectionProps, 'open' | 'setOpen'> {
  accessCode: string | null;
  classValue: OptionTypeBase | null;
}

const LoginDetails = ({ accessCode, classValue, open, setOpen }: LoginDetailsProps): JSX.Element => {

  const { translate } = useI18n();

  return (
    <CollapseSection
      headline={translate('pages.HOME.LOGIN_DETAILS.HEADLINE')}
      strapline={translate('pages.HOME.LOGIN_DETAILS.STRAPLINE')}
      open={open}
      setOpen={setOpen}
      dataCy={'home_login_details'}
    >
      { open ? <StudentLogins classValue={classValue} accessCode={accessCode} /> : null }
    </CollapseSection>
  );
};

export { LoginDetails };
